import React from 'react';
import { Card, Row, Col, Typography, Statistic } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUniversity, faDollarSign, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../contexts/AuthContext';

const { Title, Paragraph } = Typography;

const HomePage = () => {
  const { user } = useAuth();
  
  // Extract first name from fullName or email
  const getFirstName = () => {
    if (user?.fullName) {
      return user.fullName.split(' ')[0];
    }
    if (user?.email) {
      return user.email.split('@')[0].split('.')[0];
    }
    return 'User';
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={2}>
          Welcome back {getFirstName()}
        </Title>
        <Paragraph>
          Your comprehensive dashboard for managing home-related commissions and services.
        </Paragraph>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Commissions"
              value={0}
              prefix={<FontAwesomeIcon icon={faUniversity} />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Active Projects"
              value={0}
              prefix={<FontAwesomeIcon icon={faFileAlt} />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Revenue"
              value={0}
              prefix={<FontAwesomeIcon icon={faDollarSign} />}
              valueStyle={{ color: '#cf1322' }}
              precision={2}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Pending Items"
              value={0}
              prefix={<FontAwesomeIcon icon={faHome} />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Recent Activity" bordered={false}>
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
              No recent activity to display
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Quick Actions" bordered={false}>
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
              Quick action items will appear here
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default HomePage;
